import { gql } from "@apollo/client"

export const DELETE_TOUR_DISCHARGE_MUTATION = gql`
  mutation deleteHouseholdTourDischarge($updateSequence: Boolean!, $dischargeId: Float!) {
    deleteHouseholdTourDischarge(update_sequence: $updateSequence, discharge_id: $dischargeId)
  }
`
